import { emitter } from '@flowus/common/utils/emitter';
import { useEffect } from 'react';
import { message } from 'src/common/components/message';
import { useCloseModal, useOpenModal } from 'src/common/components/next-modal';
import { MessageIds, Modals } from 'src/modals';
import {
  getBackUpNoPermissionTransactions,
  triggerDownloadTransactions,
} from 'src/redux/middlewares/persistence';
import { $appUiStateCache, setAppUiState, useSyncUpFault } from 'src/services/app';

export const exportBackUpNoPermissionTransactions = async () => {
  const trs = await getBackUpNoPermissionTransactions();
  await triggerDownloadTransactions(trs, 'no-permission.json');
};

export const exportBackUpTransactions = async () => {
  await triggerDownloadTransactions();
};

export const useSyncUpFaultModal = () => {
  const openModal = useOpenModal();
  const closeModal = useCloseModal();
  const syncUpFault = useSyncUpFault();

  // 警告弹窗
  useEffect(() => {
    if (syncUpFault.backup) {
      openModal.warning({
        modalId: Modals.SYNC_UP_FAULT,
        title: '同步失败',
        autoClose: false,
        content:
          '请「刷新页面」再尝试。若遇到编辑文字丢失的情况，可前往「通用设置」中「导出本地错误日志」获取数据，或将文件发给客服恢复数据',
        confirmText: '好的',
        closeBeforeCallBackForClickOutSide: () => {
          setAppUiState({ $syncUpFault: { backup: false, noPermission: false } });
          location.reload();
        },
        // confirm: async () => {
        // await exportBackUpTransactions();
        // await sleep(500);
        // alert('请确定已下载完备份文件后，再点击确定将刷新页面，若未备份数据丢失将无法找回');
        // await clearBackupTransactions();
        // location.reload();
        // },
      });
    } else if (syncUpFault.noPermission) {
      openModal.warning({
        modalId: Modals.SYNC_UP_FAULT,
        title: '遇到无权限操作',
        content:
          '请确认你是否有操作权限。刷新页面可继续编辑。如有数据丢失，可前往「通用设置」中「导出本地错误日志」，将导出的文件发给客服来恢复数据。',
        noCancel: true,
        confirmText: '好的',
        closeBeforeCallBackForClickOutSide: () => {
          setAppUiState({ $syncUpFault: { backup: false, noPermission: false } });
          location.reload();
        },
        // cancel: async () => {
        // await clearBackupNoPermissionTransactions();
        // message.closeMessage(MessageIds.NO_PERMISSION_SYNC_WARNING_ID);
        // closeModal(Modals.SYNC_UP_FAULT);
        // location.reload();
        // },
        // confirm: async () => {
        // await exportBackUpNoPermissionTransactions();
        // await clearBackupNoPermissionTransactions();
        // message.closeMessage(MessageIds.NO_PERMISSION_SYNC_WARNING_ID);
        // closeModal(Modals.SYNC_UP_FAULT);
        // location.reload();
        // },
      });
    } else {
      closeModal(Modals.SYNC_UP_FAULT);
    }

    // 接收操作失败提示
    emitter.on('syncNoPermission', () => {
      message.warning({
        key: MessageIds.NO_PERMISSION_SYNC_WARNING_ID,
        duration: 0,
        content: (
          <>
            存在无权限操作！数据无法同步云端，你可以
            <span
              className="text-active_color animate-click ml-1"
              onClick={() => {
                setAppUiState({
                  $syncUpFault: {
                    ...$appUiStateCache.$syncUpFault,
                    noPermission: true,
                  },
                });
              }}
            >
              导出数据
            </span>
          </>
        ),
      });
    });
  }, [openModal, closeModal, syncUpFault]);
};
